export enum REMUNERATION_NAVIGATION_ACTIONS {
  SET_MODE = 'REMUNERATION_NAVIGATION_SET_MODE',
  RESET_MODE = 'REMUNERATION_NAVIGATION_RESET_MODE',
}

export enum REMUNERATION_FORM_MODE {
  list = 'list',
  createCommission = 'createCommission',
  viewCommission = 'viewCommission',
  createFixed = 'createFixed',
  viewFixed = 'viewFixed',
  createGoal = 'createGoal',
  viewGoal = 'viewGoal',
  createBonus = 'createBonus',
  viewBonus = 'viewBonus',
}
